import { render, staticRenderFns } from "./MessageProfilePic.vue?vue&type=template&id=352c22e8"
import script from "./MessageProfilePic.vue?vue&type=script&lang=js"
export * from "./MessageProfilePic.vue?vue&type=script&lang=js"
import style0 from "./MessageProfilePic.vue?vue&type=style&index=0&id=352c22e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports